import React from 'react';
import PropTypes from 'prop-types';

import ContributorBusinessCard from './ContributorBusinessCard';
import withModal from '../modal/withModal';

export const CONTRIBUTOR_BUSINESS_CARD_MODAL =
  'modals/CONTRIBUTOR_BUSINESS_CARD';

const propTypes = {
  onClose: PropTypes.func,
  onRequestClose: PropTypes.func.isRequired,
};

const ContributorBusinessCardModal = ({
  onClose,
  onRequestClose,
  ...props
}) => {
  return (
    <ContributorBusinessCard onClose={onClose ?? onRequestClose} {...props} />
  );
};

ContributorBusinessCard.propTypes = propTypes;

export default withModal(ContributorBusinessCardModal, {
  name: CONTRIBUTOR_BUSINESS_CARD_MODAL,
  className: 'contributor-business-card-modal',
  size: 'sm',
  type: 'full',
  hideHeader: true,
  dismissible: false,
});
